/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Back',
    BACK_TO_SEARCH: 'Back to search',
    CANCEL: 'Cancel',
    CANCEL_DELIVERY_REQUEST: 'Cancel request',
    CHANGE_DAY: 'Change day',
    CHANGE_LOCATION: 'Change location',
    CLICK_TO_EXPAND: 'Click or swipe to expand',
    COLLECT_PIN: 'Collection PIN',
    CONFIRM: 'Confirm',
    CURRENT_LOCATION: 'Use current location',
    EDIT_PIN: 'Edit pin',
    HELP_US_IMPROVE: 'Help us improve',
    LEAVE: 'leave',
    NEW_SEARCH: 'New search',
    PICK_UP_PIN: 'Pick up PIN',
    PICK_UP_POINT: 'Pick up point',
    SAME_LOCATION: 'Same location',
    SCAN_QR_CODE: 'Scan the QR code',
    SEARCH: 'Search',
    SIGN_IN: 'Sign in to change order request',
    SIGN_IN_FOR_EVALUATION: 'Sign in to help us improve',
    SWIPE_DOWN: 'Swipe down to hide details',
    SWIPE_UP: 'Swipe up to see details'
  },
  ERRORS: {
    SERVICE_POINT_DOES_NOT_ACCEPT_COLLECTS:
      'The service point does not accept collects!',
    SERVICE_POINT_DOES_NOT_ACCEPT_ICE:
      'The service point does not accept orders with ice packages!',
    SERVICE_POINT_DOES_NOT_HAVE_CAPACITY:
      'The service point has reached the maximum order capacity!',
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again later.',
    ZIP_CODE_WRONG_FORMAT: 'invalid zip code format'
  },
  LABELS: {
    CHANGE: 'Change',
    CLIENT_REQUEST: 'Requested by client',
    COMPANY_REQUEST: 'Requested by Prozis',
    CURRENT: 'from',
    DELETE_MESSAGE: 'Delete message!',
    ERROR: 'Error',
    NEW: 'to',
    NEW_ADDRESS: 'New address',
    OR: 'Or',
    ORIGINAL_ADDRESS: 'Original address',
    PICK_UP_POINT: 'Pick up point',
    REQUIRES_CONFIRMATION: 'Change requires confirmation',
    SAME_DAY_COLLECT: 'Same day collection',
    SAME_DAY_DELIVERY: 'Same day delivery',
    SCHEDULE: 'Schedule',
    SEARCH_LOCATION: 'Search address'
  },
  MESSAGES: {
    ADICIONAL_ADDRESS: 'Additional address',
    ADJUST_PIN: 'Adjust pin',
    BUILDING_DOOR_NUMBER: 'Building/door no.',
    CALL_US: 'call us',
    CHANGE_ADDRESS: 'Change address',
    CHANGE_ADDRESS_AUTOMATIC_COLLECT:
      'Collection request address has been changed.',
    CHANGE_ADDRESS_AUTOMATIC_DELIVERY:
      'Delivery request address has been changed.',
    CHANGE_ADDRESS_TO_PICK_UP: 'Change address to pick up point',
    CHANGE_COLLECT: 'Change collection',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_COLLECT:
      'Collection request date and address have been changed.',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_DELIVERY:
      'Order delivery date and address have been changed.',
    CHANGE_DATE_AUTOMATIC_COLLECT: 'Collection request date has been changed.',
    CHANGE_DATE_AUTOMATIC_DELIVERY: 'Delivery order date has been changed.',
    CHANGE_DAY: 'Change day',
    CHANGE_DELIVERY: 'Change delivery',
    CHAT_TITLE: 'Messages',
    CITY: 'City',
    CLIENT_REQUEST_TYPE: 'Request type',
    CONFIRM_DELETE_MESSAGE: 'Are you sure you want to delete this message?',
    CURRENT_COORDINATES: 'Current coordinates',
    CUSTOMER_SUPPORT: 'customer support',
    DATE: 'Date',
    DELETE_MESSAGE_NOW_ERROR:
      'The message cannot be deleted because it has already been read by NOW.',
    DELETED_MESSAGE: 'This message has been deleted',
    DELIVERY_HISTORY: 'History',
    DETAIL: 'Detail',
    DOOR_NUMBER: 'Door no.',
    FILL_SEARCH_FIELDS:
      'Please fill in: street, door number, zip code and city.',
    FROM: 'From:',
    HOUR: 'Hour',
    INVALID_TRACKING: 'Invalid tracking number',
    LOCATION_PREFERENCE: 'Location preference',
    MANDATORY_FIELD: 'Mandatory field.',
    MAX_CHARACTERS: 'Max. {max} characters.',
    MESSAGE: 'Message',
    MESSAGES: 'Messages',
    NEW_MESSAGE: 'New message',
    OBSERVATIONS: 'Observations',
    REQUEST_APROVED: 'Request accepted',
    REQUEST_CANCEL_TITLE: 'Cancel request',
    REQUEST_CHANGE_ADDRESS: 'Request to change address',
    REQUEST_CHANGE_DATE: 'Request to change date',
    REQUEST_CHANGE_DATE_AND_ADDRESS: 'Request to change date and address',
    REQUEST_CONTACT: 'Contact request',
    REQUEST_CONTACT_TITLE: 'Request contact',
    REQUEST_MESSAGE: 'Message request',
    REQUEST_REJECTED: 'Request rejected',
    SEARCH_ADDRESS: 'Search address',
    SEND_MESSAGE: 'New message',
    STATUS: 'Status',
    STATUS_CANCELED: 'Canceled',
    STATUS_PENDING_TREATMENT: 'Pending',
    STATUS_REJECTED: 'Rejected',
    STATUS_TREATED: 'Approved',
    STREET: 'Street',
    TO: 'To:',
    TYPE_MESSAGE: 'Type your message...',
    ZIP_CODE: 'Zip code'
  },
  SENTENCES: {
    ADDRESS_NOT_FOUND: 'Could not find the address 😞, please try again.',
    CONFIRM_CHANGE:
      'Your request has been successfully submitted. We will analyze the best way to help you 🙂.',
    CONFIRM_CHANGE_AUTOMATIC: 'Your request has been successfully accepted 🙂.',
    CONFIRM_ERROR: 'There was an error. Please try again later.',
    COORDINATES_NOT_FOUND: 'No coordinates found for the chosen address.',
    DELIVERY_REQUEST_FAIL: 'Error canceling request!',
    INVALID_DESTINATION: 'Invalid destination address!',
    MAXIMUM_CONTACT_REQUESTS:
      'You can make a maximum of {total} contact requests.',
    MAXIMUM_REACHED: 'The maximum number of requests has been reached!',
    MAXIMUM_REQUESTS: 'You can make a maximum of {total} change requests.',
    MAXIMUM_REQUESTS_LEFT: '{left} left.',
    NOT_FOUND: 'Sorry, we couldn\'t find what you\'re looking for.',
    NUMBER_OF_PACKAGES: '(with {total} packages)',
    OUT_OF_RANGE:
      'The address to which you are trying to change is beyond the reach of our NOW. To make this change, please contact our {support}.',
    PICK_UP_NOT_FOUND: 'Could not find a pick up point 😞, please try again.',
    REQUEST_CANCEL_DESCRIPTION:
      'Are you sure you want to cancel the change request?',
    REQUEST_CHANGE_APPROVED: 'Your {type} has been accepted.',
    REQUEST_CHANGE_REJECTED: 'Your {type} was not accepted.',
    REQUEST_CONTACT_APPROVED: 'We are going to answer to your {type}.',
    REQUEST_CONTACT_DESCRIPTION:
      'Upon confirmation we\'ll be in touch as soon as possible 🙂.',
    REQUEST_CONTACT_EVALUATION:
      'There is a pending contact request. We will get in touch with you soon. Thank you.',
    REQUEST_CONTACT_REJECTED: 'It won\'t be possible to reply to your {type}.',
    REQUEST_CONTACT_SUBMITTED:
      'Your request has been successfully submitted. You will be contacted by someone from PROZIS NOW as soon as possible 🙂.',
    SHOW_COLLECT_QR_CODE:
      'Show this code at the pick up point so that you can deliver what is to be collected.',
    SHOW_DELIVERY_QR_CODE:
      'Show this code at the pick up point to pick up your order.',
    STATUS_COLLECT_FAKE_PROCESSING:
      'your collection request will be processed until {date}. Thank you 😉.',
    STATUS_COLLECT_IN_INTERRUPTED_ROUTE:
      'the route is currently interrupted due to technical problems, your request will be resumed as soon as possible.',
    STATUS_COLLECT_IN_ROUTING:
      'we\'re already on our way and your pickup request will take place between {from} and {to} by {driver}. It\'s almost done 😉.',
    STATUS_COLLECT_IN_SERVICE_POINT:
      'we are waiting for you to place what you want us to collect at {name}.',
    STATUS_COLLECT_ON_THE_WAY_TO_SERVICE_POINT:
      'we\'re already on our way and your pickup request will take place between {from} and {to} by {driver} at the {name} pick up point. It\'s almost done 😉.',
    STATUS_COLLECT_PROCESSING:
      'your collection request has already been processed on {date} at {hour}. It\'s almost done 😉.',
    STATUS_COLLECT_SUCCESS:
      'your order has already been collected by {driver} on {date} at {hour}. If something\'s not right, {support}.',
    STATUS_COLLECT_UNSUCCESS: '{driver} was unable to collect your order.',
    STATUS_COLLECTED_SERVICE_POINT:
      'your order was picked up at {pickUp} on {date} at {hour}.',
    STATUS_DELIVERED_SERVICE_POINT:
      'your order {packages} was picked up at the {pickUp} pick up point on {date} at {hour}.',
    STATUS_DELIVERY_FAKE_PROCESSING:
      'your order will be processed until {date}. Thank you 😉.',
    STATUS_DELIVERY_IN_INTERRUPTED_ROUTE:
      'the route is currently interrupted due to technical problems, your request will be resumed as soon as possible.',
    STATUS_DELIVERY_IN_ROUTING:
      'your order {packages} is already on its way and will be delivered between {from} and {to} by {driver}. It\'s almost there 😉.',
    STATUS_DELIVERY_IN_SERVICE_POINT:
      'your order {packages} is ready for pick up at the {name} pick up point.',
    STATUS_DELIVERY_IN_SERVICE_POINT_UNTIL:
      'You have until {date} to pick up your order {packages}.',
    STATUS_DELIVERY_ON_THE_WAY_TO_SERVICE_POINT:
      'your order {packages} is already on its way and will be delivered between {from} and {to} by {driver} at the {name} pick up point. It\'s almost there 😉.',
    STATUS_DELIVERY_PROCESSING:
      'your order {packages} has already been processed on {date} at {hour} and is at the {location} distribution center. It\'s almost there 😉.',
    STATUS_DELIVERY_SUCCESS:
      'your order {packages} has already been delivered by {driver} on {date} at {hour}. If something\'s not right, {support}.',
    STATUS_DELIVERY_UNSUCCESS: '{driver} was unable to deliver the order.',
    STATUS_HELLO: '👋 Hello, {name},',
    UPDATING_CHANGE: 'We\'re updating your request 🙂',
    WARNING_DELIVERY_DELAY:
      'Warning: There is a delivery delay. For additional information, please contact {support}.',
    WARNING_REDUCED_EXPIRATION_DATE:
      'Warning: this order contains one or more items with a reduced shelf life and will expire on {date}. Do you wish to proceed?'
  }
};
